export const updateBomOnSaveSuccess = (state, product_quote_number) => {
  state.product_quote_number = product_quote_number;
  state.bom_line_items = state.bom_line_items.sort(
    (a, b) => a.line_in_file - b.line_in_file,
  );
  state.saved = true;
  state.view.destroy = false;
  state.view.loading = false;
  state.view.show_modal = false;
  state.view.changed_zip_file = false;
};
